export enum Tags {
  DuplicateInvoice = "Duplikat",
  Tipalti = "Tipalti",
  Pleo = "Pleo",
  KeinBeleg = "Kein Beleg",
  NoTags = "no-tags",
  Ausgang = "Ausgang",
  KlaerungMandant = "Klärung Mandant",
  Mahnung = "Mahnung",
  Lieferschein = "Lieferschein",
  Zahlungsavis = "Zahlungsavis",
  Krankenkasse = "Krankenkasse",
  Auftragsbestaetigung = "Auftragsbestätigung",
  BankKassenauszug = "Bank / Kassenauszug",
  Kreditkartenabrechnung = "Kreditkartenabrechnung",
  Vertrag = "Vertrag",
  Pfaendung = "Pfändung",
  Finanzamt = "Finanzamt",
  NullEuro = "Null Euro",
  StromWasserGasAbschlagszahlungsberechnung = "Strom / Wasser / Gas Abschlagszahlungsberechnung",
  Sonstiges = "Sonstiges",
  Unbekannt = "Unbekannt",
  KeineBuchung = "Keine Buchung",
  Duplikat = "Duplikat",
  AdressatPruefen = "Adressat Prüfen",
  AutoBuchung = "Auto-Buchung",
}

export function tagNameToColor(tagName: string) {
  if (tagName === Tags.Unbekannt) {
    return {
      backgroundColor: "#f5f5f5",
      textColor: "#333333",
    };
  }

  if (tagName === Tags.KeinBeleg) {
    return {
      backgroundColor: "rgba(242, 153, 75, 0.5)",
      textColor: "#333333",
    };
  }

  if (tagName === Tags.Duplikat) {
    return {
      backgroundColor: "rgba(239, 68, 68, 0.1)",
      textColor: "rgba(239, 68, 68, 1)",
    };
  }

  if (tagName === Tags.AdressatPruefen) {
    return {
      backgroundColor: "rgba(251, 146, 60, 0.1)",
      textColor: "rgba(251, 146, 60, 1)",
    };
  }

  if (tagName === Tags.KeineBuchung) {
    return {
      backgroundColor: "rgba(107, 114, 128, 0.1)",
      textColor: "#4b5563",
    };
  }

  return chooseRandomConsistentColorForTag(tagName);
}

function chooseRandomConsistentColorForTag(stringParam: string) {
  const hash = hashCode(stringParam);

  const seededRandom = Math.abs(Math.sin(hash) * 10000);

  const baseHue = Math.abs(hash) % 360;
  const randomOffset = (seededRandom % 360) * 1.618033988749895;
  const hue = Math.floor((baseHue + randomOffset) % 360);

  // Use fixed saturation and lightness for background (pastel)
  const bgSaturation = 85; // High saturation for distinctiveness
  const bgLightness = 90; // High lightness for pastel effect
  const backgroundColor = `hsla(${hue}, ${bgSaturation}%, ${bgLightness}%, 0.5)`;

  // For text color, use same hue but darker and more saturated
  const textSaturation = 90;
  const textLightness = 10; // Dark enough for contrast
  const textColor = `hsl(${hue}, ${textSaturation}%, ${textLightness}%)`;

  return {
    backgroundColor,
    textColor,
  };
}

function hashCode(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const character = str.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}
